import * as Sentry from '@sentry/browser'

const configEl = document.getElementById('sentry-config')
const config = configEl ? JSON.parse(configEl.textContent) : {}

if (config.dsn) {
  Sentry.init({
    dsn: config.dsn,
    environment: config.environment || 'unknown',
    release: config.release || undefined,
    beforeSend(event) {
      // Drop synthetic CustomEvent captures: Sentry's global handler
      // catches any 'error' Event that bubbles to window (e.g. cap.js
      // network failures), which surface as title "<unknown>" with no
      // stack. The widgets that dispatch them already render their own
      // error UI.
      const exc = event.exception?.values?.[0]
      if (exc?.type === 'CustomEvent' && exc.mechanism?.synthetic) {
        return null
      }
      return event
    },
  })
}

window.Sentry = Sentry
